<template>
  <div>
    <h2>
      Invoices
      <v-btn icon small @click="refreshData">
        <v-icon small>fa-sync</v-icon>
      </v-btn>

      <add-invoice-form/>
    </h2>

    <invoices-list-filter/>
    <invoices-list/>
  </div>
</template>

<script>
  import InvoicesList from "../../components/analytics/invoices/InvoicesList";
  import InvoicesListFilter from "../../components/analytics/invoices/InvoicesListFilter";
  import AddInvoiceForm from "../../components/analytics/invoices/AddInvoiceForm";
  import {mapActions} from "vuex";

  export default {
    name: 'invoices-list-page',
    components: {
      InvoicesList,
      InvoicesListFilter,
      AddInvoiceForm
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions({
        invoicesFetchFiltered: 'invoicesFetchFiltered',
      }),
      refreshData() {
        this.invoicesFetchFiltered()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/InvoicesListPage.vue